module.exports = __webpack_public_path__ + "static/img/image15.b9681f3d.png";